import { useLocalization } from "@shared-ui/localization-context";
import * as React from "react";
import { UitkText } from "uitk-react-text";
import { UitkLink } from "uitk-react-link";

interface PriceLockupGetRatesProps {
  className: string;
}

export const PriceLockupGetRates = ({ className }: PriceLockupGetRatesProps) => {
  const { formatText } = useLocalization();

  return (
    <UitkText size={300} weight="regular" className={className}>
      <UitkLink className="getRatesText">
        <span>{formatText("hotels.price.getRates")}</span>
      </UitkLink>
    </UitkText>
  );
};

export default PriceLockupGetRates;
